const generator = require('./inventoryUpdate-fullcont-multitable-generator')
const timeDate  = require('../../../../../js-handler/time-date')

export function start(detail){
         
      obj[detail.act].start(detail)
}

const obj = {
   
      add: { start: (detail)=>{ add(detail) }},
}

//add line
function add(detail){ 

      inventoryUpdateMT.forEach((mt)=>{

            if(mt.tableName === detail.tableName){
                  mt.add()
            }/*if*/
      }) 
}

export const inventoryUpdateMT = [

    {
        tableName: "inventory_update", 
        value:'', 
        id:'inventoryUpdate_form_inventory_update',
        html:'',
        data:     [],
        dataCopy: [],
        oneRequired: false,
        fields: [
            {
                name:      'purchase_code', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },

            {
                name:      'provider_name', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },

            {
                name:      'purchase_date', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },

            {
                name:      'item_description', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },

            {
                name:      'unit', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },

            {
                name:      'qty', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },

            {
                name:      'selling_price', 
                type:      'textfield',
                html:      '',
                required:  false,  
            },
        ],

        generator: function(line){ 
            line.purchase_date = timeDate.friendlyDate(line.purchase_date)
            return generator.inventory_update(line.id) 
        },

        add: function(){ }
    },
]
